import { Box, Button, styled } from '@mui/material';

import { PageContent } from './Page.styled';

export const UnifiedPageFormContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  width: '60%',
  margin: '0 auto',
}));

export const ScrollablePageContent = styled(PageContent)(({ theme }) => ({
  '.simplebar-content': {
    minHeight: '100%',
    height: 'auto',
    margin: theme.spacing(4, 0),
    boxSizing: 'border-box',
  },
}));

export const BackToLoginButton = styled(Button)(({ theme }) => ({
  position: 'static',
  marginTop: theme.spacing(8),
}));
